import {useState,useEffect} from "react";

export const useAudio = url => {
    const [audio] = useState(typeof Audio!=="undefined" && new Audio(url));
    const [playing, setPlaying] = useState(false);
  
    const toggle = () => {
    audio.muted=false
    setPlaying(!playing)
    }


   useEffect(()=>{
  
   audio.muted=true

   },[audio])



    useEffect(() => {
     function mach(){
      playing ? audio!==undefined&&audio.play() : audio!==undefined&&audio.pause();
     }
      setTimeout(mach(),400)
     
      },
      [playing,audio] 
    );
  
    useEffect(() => {
     audio!==undefined&& audio.addEventListener('ended', () => setPlaying(false));
      return () => {
        audio!==undefined&&audio.removeEventListener('ended', () => setPlaying(false));
      };
    },[playing,audio]);
  
    return [playing, toggle];
  };
  
  